import { collection, getDocs, doc, setDoc, deleteDoc, writeBatch } from "firebase/firestore";
import { db } from "../Firebase";

export const defaultGalleryItems = [
  {
    id: 'gal-1',
    title: 'Jio Telecom Tower Maintenance',
    category: 'telecom',
    desc: 'Preventive maintenance, check of electrical connections, speed governor, and fuel level telemetry at Jio cell tower node.',
    image: '/sitevisit/WhatsApp Image 2026-07-08 at 4.25.24 PM.jpeg'
  },
  {
    id: 'gal-2',
    title: 'TMTL Silent Generator Commissioning',
    category: 'sales',
    desc: 'Rooftop deployment and testing of a TMTL silent series generator at a corporate commercial facility.',
    image: '/sitevisit/WhatsApp Image 2026-07-08 at 4.25.50 PM.jpeg'
  },
  {
    id: 'gal-3',
    title: 'Rooftop Solar Panel EPC Installation',
    category: 'solar',
    desc: 'Inspection of a newly commissioned commercial rooftop solar plant using high-efficiency solar modules.',
    image: '/sitevisit/WhatsApp Image 2026-07-08 at 4.26.54 PM.jpeg'
  },
  {
    id: 'gal-4',
    title: 'LT Control Panel Commissioning',
    category: 'panels',
    desc: 'Testing of an automatic transfer switch (ATS) and electrical distribution control panel at an industrial site.',
    image: '/sitevisit/WhatsApp Image 2026-07-08 at 4.30.11 PM.jpeg'
  },
  {
    id: 'gal-5',
    title: 'Generator Alternator Setup and Wiring',
    category: 'rental',
    desc: 'Terminal wiring and testing of Stamford alternator inside a silent acoustic canopy for a site installation.',
    image: '/sitevisit/WhatsApp Image 2026-07-08 at 4.30.54 PM.jpeg'
  }
];

export const getGalleryItems = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "gallery"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });

    if (list.length === 0) {
      // Prepopulate Firestore
      const batch = writeBatch(db);
      defaultGalleryItems.forEach((item) => {
        const docRef = doc(collection(db, "gallery"), item.id);
        batch.set(docRef, item);
      });
      await batch.commit();
      return defaultGalleryItems;
    }
    
    // Sort items consistently (latest added first)
    list.sort((a, b) => b.id.localeCompare(a.id));
    return list;
  } catch (error) {
    console.error("Error fetching gallery items from Firestore: ", error);
    throw error;
  }
};

export const saveGalleryItem = async (item) => {
  try {
    const docRef = doc(db, "gallery", item.id);
    await setDoc(docRef, item, { merge: true });
  } catch (error) {
    console.error("Error saving gallery item to Firestore: ", error);
    throw error;
  }
};

export const deleteGalleryItem = async (id) => {
  try {
    const docRef = doc(db, "gallery", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting gallery item from Firestore: ", error);
    throw error;
  }
};

export const defaultGalleryCategories = [
  { id: 'cat-sales', name: 'Generator Sales', slug: 'sales' },
  { id: 'cat-rental', name: 'Generator Rental', slug: 'rental' },
  { id: 'cat-panels', name: 'Electrical Panels', slug: 'panels' },
  { id: 'cat-solar', name: 'Solar Solutions', slug: 'solar' },
  { id: 'cat-telecom', name: 'Telecom Operations', slug: 'telecom' }
];

export const getGalleryCategories = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "galleryCategories"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    if (list.length === 0) {
      const batch = writeBatch(db);
      defaultGalleryCategories.forEach((cat) => {
        const docRef = doc(collection(db, "galleryCategories"), cat.id);
        batch.set(docRef, cat);
      });
      await batch.commit();
      return defaultGalleryCategories;
    }
    return list;
  } catch (error) {
    console.error("Error fetching gallery categories from Firestore: ", error);
    throw error;
  }
};

export const saveGalleryCategory = async (cat) => {
  try {
    const docRef = doc(db, "galleryCategories", cat.id);
    await setDoc(docRef, cat, { merge: true });
  } catch (err) {
    console.error("Error saving gallery category: ", err);
    throw err;
  }
};

export const deleteGalleryCategory = async (id) => {
  try {
    const docRef = doc(db, "galleryCategories", id);
    await deleteDoc(docRef);
  } catch (err) {
    console.error("Error deleting gallery category: ", err);
    throw err;
  }
};
